import styled from 'styled-components';
import Icon from '/imports/ui/components/common/icon/component';
import { barsPadding, borderSize } from '/imports/ui/stylesheets/styled-components/general';
import {
  colorWhite,
  colorDanger,
  colorGrayDark,
  colorBackground,
  colorGray,
  colorPrimary,
  colorOffWhite,
  colorBlue,

} from '/imports/ui/stylesheets/styled-components/palette';
import { fontSizeBase, fontSizeLarge, fontSizeLarger } from '/imports/ui/stylesheets/styled-components/typography';
import { phoneLandscape, smallOnly } from '/imports/ui/stylesheets/styled-components/breakpoints';
import Button from '/imports/ui/components/common/button/component';

const Navbar = styled.header`
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 1.5rem;
  background-color: ${colorWhite};
  z-index:2;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  ${'' /* background-color: ${colorPrimary}; */}
  padding : 0;
  ${'' /* padding: ${barsPadding} ${barsPadding} 0 ${barsPadding}; */}
  ${'' /* padding: ${barsPadding} ${barsPadding} 0 0; */}
  ${'' /* @media (max-width: 768px) {
    flex-wrap: wrap;
  } */}
  > div{
    @media ${smallOnly} {
      flex-wrap: wrap;
    }
  }
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  @media ${smallOnly} {
    width: 100%;
    padding : .25rem .5rem;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right : auto;
  padding-right:.5rem;
  ${'' /* padding: 0 10px; */}
`;

const ArrowLeft = styled(Icon)`
  position: absolute;
  font-size: 40%;
  ${'' /* color: ${colorWhite};  */}
  color: ${colorGrayDark};
  left: .25rem;
  z-index:111;
  @media ${smallOnly} {
    display: none;
  }
`;

const ArrowRight = styled(Icon)`
  position: absolute;
  font-size: 40%;
  ${'' /* color: ${colorWhite};  */}
  color: ${colorGrayDark};
  right: .0125rem;
  z-index:111;
  @media ${smallOnly} {
    display: none;
  }
`;

const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70%;
  flex: 1;
   @media ${smallOnly} {
    justify-content: start;
    width:100%;
    ${'' /* margin-left : 10px; */}
    order : 3
  }
`;

const PresentationTitle = styled.h1`
  font-weight: 400;
  color: ${colorBlue};
  ${'' /* color : ${colorBlue}; */}
  font-size: ${fontSizeBase};
  margin: 0;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  cursor: pointer;

  > [class^="icon-bbb-"] {
    font-size: 75%;
  }

  @media ${smallOnly} {
    padding-right: .5rem;
    max-width: 100%;
   }
  & span i {
    margin-left: .5rem;
    margin-right: .5rem;
    font-size: .75rem;
  }
`;



const LessionTitle = styled.p`
  color: ${colorBlue};
  font-size: ${fontSizeLarge};
  font-weight : 600;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  cursor: pointer;

  > [class^="icon-bbb-"] {
    font-size: 75%;
  }

  @media ${smallOnly} {
    max-width: inherit;
    flex-shrink: 0;
  }

  & span i {
    margin-left: .5rem;
    margin-right: .5rem;
    font-size: .75rem;
  }

`;

const UserWraaper = styled.div`
  display:flex;
  align-items:center;

  ${'' /* color: ${colorGrayDark};
  font-size: ${fontSizeBase};
  font-weight : 600;
  margin: 0 5px;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  cursor: pointer;

  > [class^="icon-bbb-"] {
    font-size: 75%;
  }

  & span i {
    margin-left: .5rem;
    margin-right: .5rem;
    font-size: .75rem;
  } */}
`;
const UserNameTitle = styled.p`
  color: ${colorGrayDark};
  font-size: ${fontSizeBase};
  font-weight : 600;
  margin: 0 5px;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
  cursor: pointer;

  > [class^="icon-bbb-"] {
    font-size: 75%;
  }

  & span i {
    margin-left: .5rem;
    margin-right: .5rem;
    font-size: .75rem;
  }
  @media ${smallOnly} {
    display: none;
  }
`;


const PluginInfoComponent = styled.h1`
  font-weight: 400;
  color: ${colorWhite};
  font-size: ${fontSizeBase};
  margin: 0;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30vw;
`;

const PluginComponentWrapper = styled.div`
  margin: 0 .5rem;
`;

const PluginSeparatorWrapper = styled.div`
  color: ${colorGray};
  font-size: ${fontSizeBase};
  margin: 0 1rem;
`;

const Right = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 0;
    @media ${smallOnly} {
    ${'' /* width: 100%; */}
    ${'' /* margin-top: 0.5rem; */}
    ${'' /* order: 2; // ensures it comes after Top */}
    flex:none;
    ${'' /* justify-content:space-between; */}
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  ${'' /* width: calc(100vw - 150px); */}
  width : 70%;
  @media ${phoneLandscape} {
    margin-top: .25rem;
  }
`;

const NavbarToggleButton = styled(Button)`
  margin: 0;
  z-index: 3;

  ${({ hasNotification }) => hasNotification && `
    position: relative;

    &:after {
      content: '';
      position: absolute;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      bottom: ${borderSize};
      right: 3px;
      background-color: ${colorDanger};
      border: ${borderSize} solid ${colorGrayDark};
    }
  `}
   @media ${smallOnly} {
    margin-left: .5rem;
  }
`;
const Image = styled.div`
  display: flex;
  height: 34px;
  width: 34px;
  margin:0px 5px;
  ${'' /* justify-content: center; */}
  border:3px solid #00265d;
  border-radius : 50%
`;
const ProfileImage = styled.div`
  display: flex;
  height: 34px;
  width: 34px;
  margin: 0px 10px;
  ${'' /* justify-content: center; */}
  ${'' /* border:3px solid #00265d; */}
  border-radius : 50%
`;
const Img = styled.img`
  object-fit: cover;
  overflow: hidden;
  border-radius: 50%;
`;

const PresentationTitleSeparator = styled.span`
  color: ${colorGray};
  font-size: ${fontSizeBase};
  margin: 0 0.5rem;
`;
export default {
  Navbar,
  Image,
  Top,
  Left,
  Img,
  ArrowLeft,
  ArrowRight,
  Center,
  PresentationTitle,
  Right,
  Bottom,
  NavbarToggleButton,
  PluginInfoComponent,
  PluginComponentWrapper,
  PluginSeparatorWrapper,
  LessionTitle,
  PresentationTitleSeparator,
  ProfileImage,
  UserNameTitle,
  UserWraaper
};
